import React, { useState } from "react";
import { useTranslation } from "react-i18next";

function CustomGoalInput({ onAISuggestions, onCustomGoal, onBack }) {
  const { t } = useTranslation('fastresearch');
  const [customGoal, setCustomGoal] = useState("");

  return (
    <>
      <h1 style={{
        fontSize: "clamp(2rem, 8vw, 2.75rem)",
        marginBottom: "1rem",
        fontWeight: "900",
        color: "#fff",
        letterSpacing: "-0.04em",
        lineHeight: "1",
        textAlign: "center"
      }}>
        {t('customGoal.title')}
      </h1>

      <p style={{
        fontSize: "clamp(0.9375rem, 3vw, 1rem)",
        color: "#888",
        marginBottom: "2rem",
        lineHeight: "1.5",
        textAlign: "center"
      }}>
        {t('customGoal.subtitle')}
      </p>

      {/* AI Suggestions Button */}
      <button
        onClick={onAISuggestions}
        style={{
          width: "100%",
          padding: "1.125rem 1.25rem",
          marginBottom: "1rem",
          fontSize: "clamp(0.9375rem, 3.5vw, 1rem)",
          fontWeight: "700",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          borderRadius: "10px",
          backgroundColor: "rgba(255, 255, 255, 0.05)",
          color: "#fff",
          cursor: "pointer",
          transition: "all 0.3s ease",
          textAlign: "left",
          display: "flex",
          alignItems: "center",
          gap: "0.75rem"
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "rgba(99, 102, 241, 0.1)";
          e.currentTarget.style.borderColor = "rgba(99, 102, 241, 0.3)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
          e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.1)";
        }}
      >
        <div style={{ color: "#a78bfa", flexShrink: 0, display: "flex", alignItems: "center" }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
        </div>
        <span>{t('customGoal.getAISuggestions')}</span>
      </button>

      {/* Divider */}
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "1rem",
        marginBottom: "1.5rem"
      }}>
        <div style={{ flex: 1, height: "1px", backgroundColor: "rgba(255, 255, 255, 0.1)" }} />
        <span style={{ fontSize: "0.75rem", color: "#666", fontWeight: "700" }}>{t('customGoal.or')}</span>
        <div style={{ flex: 1, height: "1px", backgroundColor: "rgba(255, 255, 255, 0.1)" }} />
      </div>

      {/* Custom Goal Input */}
      <div style={{ marginBottom: "1.5rem" }}>
        <label style={{
          display: "block",
          fontSize: "clamp(0.875rem, 3vw, 0.9375rem)",
          fontWeight: "700",
          color: "#a78bfa",
          marginBottom: "0.75rem"
        }}>
          {t('customGoal.describeGoal')}
        </label>
        <input
          type="text"
          value={customGoal}
          onChange={(e) => setCustomGoal(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.nativeEvent.isComposing && customGoal.trim()) {
              onCustomGoal(customGoal.trim());
            }
          }}
          placeholder={t('customGoal.placeholder')}
          autoFocus
          style={{
            width: "100%",
            padding: "1rem 1.25rem",
            fontSize: "clamp(0.9375rem, 3.5vw, 1rem)",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            borderRadius: "10px",
            backgroundColor: "rgba(255, 255, 255, 0.08)",
            color: "#fff",
            outline: "none",
            transition: "all 0.3s ease",
            fontWeight: "600"
          }}
          onFocus={(e) => {
            e.target.style.borderColor = "rgba(99, 102, 241, 0.5)";
            e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
          }}
          onBlur={(e) => {
            e.target.style.borderColor = "rgba(255, 255, 255, 0.2)";
            e.target.style.backgroundColor = "rgba(255, 255, 255, 0.08)";
          }}
        />
      </div>

      {/* Action buttons */}
      <div style={{ display: "flex", gap: "0.75rem" }}>
        <button
          onClick={onBack}
          style={{
            flex: 1,
            padding: "clamp(1rem, 3vh, 1.25rem)",
            fontSize: "clamp(0.9375rem, 3.5vw, 1rem)",
            fontWeight: "700",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            borderRadius: "10px",
            backgroundColor: "rgba(255, 255, 255, 0.05)",
            color: "#888",
            cursor: "pointer",
            transition: "all 0.3s ease"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.08)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
          }}
        >
          {t('customGoal.back')}
        </button>

        <button
          onClick={() => {
            if (customGoal.trim()) {
              onCustomGoal(customGoal.trim());
            }
          }}
          disabled={!customGoal.trim()}
          style={{
            flex: 2,
            padding: "clamp(1rem, 3vh, 1.25rem)",
            fontSize: "clamp(0.9375rem, 3.5vw, 1rem)",
            fontWeight: "800",
            border: "none",
            borderRadius: "10px",
            backgroundColor: customGoal.trim() ? "#fff" : "rgba(255, 255, 255, 0.1)",
            color: customGoal.trim() ? "#000" : "#555",
            cursor: customGoal.trim() ? "pointer" : "not-allowed",
            transition: "all 0.3s ease",
            letterSpacing: "0.02em"
          }}
          onMouseEnter={(e) => {
            if (customGoal.trim()) {
              e.currentTarget.style.backgroundColor = "#a78bfa";
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = customGoal.trim() ? "#fff" : "rgba(255, 255, 255, 0.1)";
          }}
        >
          {t('customGoal.continue')}
        </button>
      </div>
    </>
  );
}

export default CustomGoalInput;
